import Tag from "./Tag";
import classes from "./index.module.scss";
import { v4 as uuid } from "uuid";
import { useDeferredValue } from "react";

export default function TagsList({
  toggleActiveTag,
  checkIsTagActive,
  tags,
  setPage,
  resetTags,
  activeTags,
  entity,
}) {
  const deferredTags = useDeferredValue(tags);

  if (!deferredTags?.data.length) return null;

  return (
    <>
      <button
        onClick={() => {
          if (activeTags.length) {
            setPage(1);
            resetTags(entity);
          }
          return;
        }}
        className={classes.reset}
      />
      <ul className={classes.tags}>
        {deferredTags.data.map((tag) => (
          <li key={uuid()}>
            <Tag
              toggleActiveTag={toggleActiveTag}
              checkIsTagActive={checkIsTagActive}
              tag={tag}
              setPage={setPage}
              entity={entity}
            />
          </li>
        ))}
      </ul>
    </>
  );
}
